export default "__VITE_ASSET__c4a06206__"